import styled from 'styled-components'

export const WhiteModal = styled.div`
    width: 70rem;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    top: 30%;
    
    h3{
        text-align: center;
        margin-bottom: 1rem;
        color: var(--terc4);
    }
    background: white;
    border-radius: 0.625rem;
    box-shadow: var(--SombraBtns);
 `
